import React from 'react'

import { reportError } from 'utils/errorReporter'
import styles from '../styles'

const BuildComplianceList = (props) => {
  const { complianceListData } = props
  const classes = styles()
  try {
    return (
      <div className={classes.expansibleContent}>
        {complianceListData.consists ? (
          <span>
            O candidato se encontra na {`"${complianceListData.reason}"`}.
          </span>
        ) : (
          <span>
            O candidato {`${complianceListData.reason.toLowerCase()}`}.
          </span>
        )}
      </div>
    )
  } catch (err) {
    reportError(err)
    return (
      <div className={classes.errorCaptured}>
        <span>Ocorreu um erro ao tratar os dados</span>
      </div>
    )
  }
}

export default BuildComplianceList
